import React from 'react';
import classNames from 'classnames';
import VideoPlayer from '../VideoPlayer/VideoPlayer';
import Button from '../Button/Button';

const FeaturedVideos = ({
  bgClass = '',
  tag = '',
  title = '',
  ctaText = '',
  ctaUrl = '',
  videos = [],
}) => {
  const btnClass = classNames('btn btn--default', {
    'btn--inverted':
      bgClass.includes('bg-blue-dark') ||
      bgClass.includes('bg-blue-dark-gradient'),
  });

  const tagClass = classNames('tag', {
    'bg-blue-dark': bgClass.includes('bg-blue-dark-gradient'),
  });

  return (
    <div className={`featured-videos ${bgClass}`}>
      <div className="featured-videos__wrapper container">
        <div className="featured-videos__intro">
          {tag && <div className={tagClass}>{tag}</div>}
          <div className="featured-videos__title">{title}</div>
          {ctaText && ctaUrl && (
            <div className="featured-videos__cta">
              <Button className={btnClass} text={ctaText} href={ctaUrl} />
            </div>
          )}
        </div>
        {videos && (
          <div className="featured-videos__items">
            {videos.map(
              (video, index) =>
                video.title &&
                video.videoUrl && (
                  <div
                    key={`featured-videos-${index}`}
                    className="featured-videos__item"
                  >
                    <div className="video-videos__item-video">
                      <VideoPlayer {...video} />
                    </div>
                    <div className="featured-videos__item-title">
                      {video.title}
                    </div>
                  </div>
                )
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturedVideos;
